import { render, staticRenderFns } from "./Datarequest.vue?vue&type=template&id=f863105a&scoped=true&"
import script from "./Datarequest.vue?vue&type=script&lang=js&"
export * from "./Datarequest.vue?vue&type=script&lang=js&"
import style0 from "./Datarequest.vue?vue&type=style&index=0&id=f863105a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f863105a",
  null
  
)

export default component.exports